<div class="notification-dialog">
    <div class="close-button" (click)="closeDialog()">&times;</div>
    <div class="dialog-title"><strong>Notification</strong></div>
    <p class="notification-message">{{ notification.message }}</p>
    <!-- <p class="notification-status">Read: {{ notification.read ? 'Yes' : 'No' }}</p> -->
    <!-- Add other notification properties here if needed -->
  </div>